import { useQuery } from '@tanstack/react-query';

import * as externalApi from '@/apis/external';
import type { POLICY_FILES } from '@/constants';
import type { CommonUseQueryOptions } from '@/types/app';
import { getQueryKey } from '@/utils/queryKeys';

export const useGetPolicy = (
  key: string,
  options?: CommonUseQueryOptions<string>
) => {
  const query = useQuery({
    queryKey: getQueryKey(
      'external:getPolicy',
      key as keyof typeof POLICY_FILES
    ),
    queryFn: () =>
      externalApi.getPolicyFromS3(key as keyof typeof POLICY_FILES),
    ...options,
  });

  return query;
};
